import { codeSplit, Controller, FetchOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { SearchResultsStore } from 'stores/search-results-store';

export class GroundTransportationSearchController implements Controller {
  public bundles = ['gts'];
  public component = codeSplit(() => import(/* webpackChunkName: "search" */ 'src/common/views/ground-transportation/search'));
  public pageId = 'page.LX-GT-Search,GT,20';
  public path = '/ground-transfers/search';
  public exact = true;
  public routeName = 'GroundTransportationSearch';
  public routeData = {
    rfrrNamespace: 'GT.SRP',
    pageName: 'GROUNDTRANSFERS',
  };

  public fetch(options: FetchOptions): Promise<any> {
    if (!options?.stores) {
      return Promise.reject('GroundTransportationSearchController.fetch received an invalid StoreContainer');
    }

    const { query, stores } = options;

    const searchResults: SearchResultsStore = stores.get<SearchResultsStore>('searchResults');

    if (!searchResults.searchCriteria) {
      return Promise.reject('Missing searchCriteria store');
    }
    // This line is necessary to render the <Sidebar/> component
    searchResults.searchCriteria.regionId = query.regionId as string;

    return Promise.resolve();
  }
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      title: 'Ground Transportation, noice!',
      seo: {
        robots: 'noindex',
      },
    }) as Promise<PageData>;
  }
}
